import React, { createContext, useMemo } from 'react';
import {
  IOrgsSelectFilterResult,
  useOrgsSelectFilter,
} from '../../../hooks/useOrgsSelectFilter';

interface IUserFormContext {
  orgsSelectFilterResult: IOrgsSelectFilterResult;
}

export const UserFormContext = createContext<IUserFormContext>({
  orgsSelectFilterResult: {
    orgsSelectorLoading: false,
    orgsSelectorSearching: false,
    orgsSelectorHasError: false,
    orgsSelectorIsSuccess: false,
    orgOptions: [],
    setOrgsSelectSearchCriteria: () => {
      // do nothing
    },
  },
});

export const UserFormContextProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const orgsSelectFilterResult = useOrgsSelectFilter();

  const contextValue = useMemo(
    () => ({ orgsSelectFilterResult }),
    [orgsSelectFilterResult]
  );
  return (
    <UserFormContext.Provider value={contextValue}>
      {children}
    </UserFormContext.Provider>
  );
};
